import * as Service from './service';
import { isFunction } from 'lodash';

export const serviceMethods = (fields, options, serviceType, serviceName, serviceCallHandler) => {
    return {
        go: () => {
            return Service.goPrototype(
                fields,
                options,
                serviceType,
                serviceName,
                serviceCallHandler
            );
        },
        validate: () => {
            return Service.validate(fields, options, serviceType, serviceName);
        }
    };
};

export default (fields, serviceType, serviceName, handleServiceCall, handleBatchServiceCall) => {
    const batchFields = {
        batchItems: fields
    };

    return (options = {}) => {
        if (options.batchItems && isFunction(handleBatchServiceCall)) {
            const batchOptions = {
                batchMode: options.batchMode,
                batchItems: options.batchItems,
                key: options.key
            };
            return serviceMethods(batchFields, batchOptions, serviceType, serviceName, handleBatchServiceCall);
        }
        return serviceMethods(fields, options, serviceType, serviceName, handleServiceCall);
    };
};



// WEBPACK FOOTER //
// ./services/services/serviceFactory.js